'use client';

import React, { useState } from 'react';
import CheckoutCard from '@next-app/components/Checkout/CheckoutCard/CheckoutCard';
import LLButton from '@next-app/components/elements/LLButton/LLButton';
import Image from 'next/image';
import Conditional from '@next-app/components/Conditional';
import Heading from '@next-app/components/elements/Heading/Heading';
import { useSelector } from 'react-redux';
import { selectOrderSummaryInfo } from '@next-app/lib/features/checkout/CheckoutSelector';
import downArrow from '../../../../public/react/assets/icons/arrow-down-heavy.svg';

interface OrderSummaryMobileProps {
  children: React.ReactNode;
}

const OrderSummaryMobile: React.FC<OrderSummaryMobileProps> = ({
  children,
}) => {
  const [showOrderSummaryCollapse, setShowOrderSummaryCollapse] =
    useState<boolean>(false);
  const handleToggle = () => {
    setShowOrderSummaryCollapse((prev) => !prev);
  };

  /**
   * Use Selector
   */
  const orderSummaryInfo = useSelector(selectOrderSummaryInfo);

  /***
   * Order Summary Heading
   */
  const RenderOrderSummaryHeading = () => {
    return (
      <div
        className={`d-flex justify-content-between align-items-center ${showOrderSummaryCollapse ? 'border-bottom p-ll-3 pt-0' : ''}`}
        style={{ margin: `${showOrderSummaryCollapse ? '0 -15px' : ''}` }}
      >
        <Heading tagName="5" customClass="fs-base fw-normal m-0 flex-grow-1">
          Order Summary
        </Heading>
        <div className="me-ll-3 fw-medium">
          {orderSummaryInfo?.orderShippingCharge === 'tbd'
            ? 'tbd'
            : orderSummaryInfo?.displayTotal}
        </div>
        <Conditional if={showOrderSummaryCollapse}>
          <LLButton
            customClass={`arrow-btn up`}
            onClick={() => setShowOrderSummaryCollapse(false)}
          >
            <Image
              src={downArrow}
              alt="down-arrow"
              height="12"
              width="12"
              unoptimized={true}
            />
          </LLButton>
        </Conditional>
      </div>
    );
  };

  return (
    <div
      className={`d-block d-lg-none mb-ll-3 bg-light ${showOrderSummaryCollapse ? 'border-top' : ''}`}
      style={{ margin: '0 -15px' }}
    >
      <CheckoutCard
        showCollapse={showOrderSummaryCollapse}
        setShowCollapse={handleToggle}
        mobileView={true}
        customClass="ps-ll-3 pe-ll-3 align-items-center brd-rond-lg border-top"
        childClass="flex-grow-1"
      >
        <Conditional if={!showOrderSummaryCollapse}>
          <RenderOrderSummaryHeading />
        </Conditional>
      </CheckoutCard>
      <Conditional if={showOrderSummaryCollapse}>
        <div className="pt-ll-3 ps-ll-3 pe-ll-3">
          <RenderOrderSummaryHeading />
          <div className="d-flex d-lg-block flex-column">{children}</div>
        </div>
      </Conditional>
    </div>
  );
};

export default OrderSummaryMobile;
